import { TABLE_1 } from "../constants.js";
import "../types.js";
export function DurationRecordSign(record) {
	for (const key of TABLE_1) {
		if (record[key] < 0) {
			return -1;
		}
		if (record[key] > 0) {
			return 1;
		}
	}
	return 0;
}
